import React from 'react';
import ReactDOM from 'react-dom/client';
import {MantineProvider} from "@mantine/core";
import { Notifications } from '@mantine/notifications';
import {BotProvider} from "./bot/BotContext";
import AppContent from "./App";

/**
 * Entry point for the React application.
 * Sets up the Mantine UI provider and the global Bot game context.
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <MantineProvider defaultColorScheme="dark">
            <Notifications />
            <BotProvider>
                <AppContent/>
            </BotProvider>
        </MantineProvider>
    </React.StrictMode>
);
